import formatFunctions from '@/utils/formatFunctions'

export default {
    ...formatFunctions
}